import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["campsiteType"]

  connect() {
    if (this.hasCampsiteTypeTarget && this.campsiteTypeTarget.value) {
      this.updatePreviews()
    }
  }

  campsiteTypeChanged(event) {
    this.updatePreviews()
  }

  async updatePreviews() {
    const campsiteType = this.campsiteTypeTarget.value
    if (!campsiteType) {
      const previewsDiv = document.getElementById('image-previews')
      if (previewsDiv) {
        previewsDiv.innerHTML = '<p class="text-sm text-zinc-500 dark:text-zinc-400">Select a campsite type to see sample images.</p>'
      }
      return
    }

    try {
      const response = await fetch(`/admin/rentals/sample_images?campsite_type=${campsiteType}`, {
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })
      
      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      }
    } catch (error) {
      console.error("Error fetching previews:", error)
      const previewsDiv = document.getElementById('image-previews')
      if (previewsDiv) {
        previewsDiv.innerHTML = '<p class="text-sm text-red-500">Error loading previews. Please try again.</p>'
      }
    }
  }
}
